import { Injectable, Inject } from '@angular/core';
import { tap, catchError, timeInterval, map } from 'rxjs/operators';
import { Observable, throwError, TimeoutError } from 'rxjs';
import { ConnectionStateService } from '@ildes/services/connection-state.service';
import { debounceTime } from 'rxjs/operators';
import { environment } from '../../environments/environment';

const WHITE_LIST = ['/jsonplaceholder', '/version'];

import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';

@Injectable()
export class ConnectionStateInterceptor implements HttpInterceptor {

  private updateConnectionSubject;
  constructor(
    private connectionState: ConnectionStateService
    ) {

  }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<any> {

    if (!WHITE_LIST.filter((signature) => req.url.indexOf(signature) >= 0 ).length) {
      this.connectionState.pushRequest(req);
      return next.handle(req).pipe(
        tap((response) => {
          if (!(response instanceof HttpResponse)) {
            return;
          }
          const beginFromTimeout = Boolean(response.headers.get('X-timeout'));
          const beginFromCache = Boolean(response.headers.get('X-cache'));
          this.connectionState.removeRequest(req, beginFromTimeout, beginFromCache);
        }),
        catchError((error) => {
          this.connectionState.removeRequest(req, error instanceof TimeoutError);
          return throwError(error);
        })
      )
    }

    return next.handle(req);
  }
}
